import { connect } from 'react-redux'

import EmergencyContactForm from 'app/profile/renter/emergency_contact/emergency_contact_form'
import { fetchApplication } from 'app/sm/apply/apply_actions'
import {
  createEmergencyContact,
  editEmergencyContact,
  getEmergencyContact,
  removeEmergencyContact,
} from 'app/sm/emergency_contact/emergency_contact_actions'

const mapStateToProps = ({ EmergencyContact, apply }) => ({
  emergencyContact: EmergencyContact.emergencyContact,
  error: EmergencyContact.error,
  applicationDetails: apply.application,
})

const mapDispatchToProps = (dispatch) => ({
  createEmergencyContact: (formData) =>
    dispatch(createEmergencyContact(formData)),
  editEmergencyContact: (formData, id) =>
    dispatch(editEmergencyContact(formData, id)),
  removeEmergencyContact: (id) => dispatch(removeEmergencyContact(id)),
  getEmergencyContact: (id) => dispatch(getEmergencyContact(id)),
  fetchApplication: (applicationId) =>
    dispatch(fetchApplication(applicationId)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EmergencyContactForm)
